import { Outlet } from "react-router-dom";


const BannerFooter = () => {
  return (<Outlet />)
}
export default BannerFooter;
